import { Grid } from "@material-ui/core";
import { useContasPagarService } from "../../context/ContasPagarContext";
import ReportTable from "./ReportTable";

const ReportDataGrid = () => {
  const { isGrouped, cachedMovementData } = useContasPagarService();

  if (!cachedMovementData.length) {
    return (
      <Grid item xs={12} style={{ marginBottom: 16 }} key={"empty-table"}>
        <ReportTable data={[]} emptyMessage="Sem Movimentação" />
      </Grid>
    );
  }

  return (
    <Grid item container>
      <Grid item xs={12}>
        <ReportTable
          data={cachedMovementData}
          emptyMessage="Sem Movimentação"
          isGrouped={isGrouped}
        />
      </Grid>
    </Grid>
  );
};

export default ReportDataGrid;
